import { render, staticRenderFns } from "./TipoVehiculoModalEdicion.vue?vue&type=template&id=04760942&scoped=true&"
import script from "./TipoVehiculoModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./TipoVehiculoModalEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./TipoVehiculoModalEdicion.vue?vue&type=style&index=0&id=04760942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04760942",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('04760942', component.options)
    } else {
      api.reload('04760942', component.options)
    }
    module.hot.accept("./TipoVehiculoModalEdicion.vue?vue&type=template&id=04760942&scoped=true&", function () {
      api.rerender('04760942', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/plataforma/TipoVehiculoModalEdicion.vue"
export default component.exports